/**
 * main-login-c95.js
 * ログインとパスワードリセットフォーム切り替え機能
 */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const toggleForms = function () {
      const loginForm = document.getElementById("login-form");
      const recoverForm = document.getElementById("recover-form");

      // URLのハッシュに基づいて初期表示を設定
      const showRecoverForm = window.location.hash === "#recover";

      if (showRecoverForm) {
        loginForm.style.display = "none";
        recoverForm.style.display = "block";
      } else {
        loginForm.style.display = "block";
        recoverForm.style.display = "none";
      }

      // フォーム切り替えリンクにイベントリスナーを設定
      const toggleLinks = document.querySelectorAll(".js-toggle-form");
      toggleLinks.forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          if (loginForm.style.display === "block") {
            loginForm.style.display = "none";
            recoverForm.style.display = "block";
            window.history.pushState({}, "", "#recover");
            document.getElementById("RecoverEmail").focus();
          } else {
            recoverForm.style.display = "none";
            loginForm.style.display = "block";
            window.history.pushState({}, "", "#login");
            document.getElementById("CustomerEmail").focus();
          }
        });
      });
    };

    // ハッシュの変更を監視
    window.addEventListener("hashchange", toggleForms);

    // 初期化
    toggleForms();
  });
})();
